import * as PIXI from "pixi.js";
import Layers from "../../layers/Layers";
import AngleValue from "./AngleValue";
import { drawSquare, drawArc } from "./helpers/drawHelpers";
import { AngleColor, Coord } from "../../types/Interface";


export default class Angle extends PIXI.Container {
  Layers = Layers.getInstance();
  AngleValue: AngleValue;
  arc!: PIXI.Graphics
  arcStroke!: PIXI.Graphics;
  tag: string;
  startRadian!: number;
  endRadian!: number;
  degree!: number;
  fillColor: number;
  smallDistance: number = 100;
  smallDistanceOffset: number = 0;
  addSmallDis = true;

  constructor(tag: string, angleColor: AngleColor, smallDistanceOffset: number = 0, addCon: boolean = false, addSmallDis: boolean = true) {
    super();
    this.tag = tag;
    this.fillColor = angleColor.color;
    this.smallDistanceOffset = smallDistanceOffset;
    this.addSmallDis = addSmallDis;
    this.AngleValue = new AngleValue({ x: -100, y: -100 }, angleColor.textColor);
    this.addArc();
    !addCon && this.addToLayer();
  }
  private addToLayer = () => this.Layers.Bottom.addChild(this);

  private addArc() {
    this.arc = new PIXI.Graphics();
    this.addChild(this.arc);
    this.arcStroke = new PIXI.Graphics();
    this.addChild(this.arcStroke);
  }
  setVisible(status: boolean) {
    this.visible = status;
    this.AngleValue.visible = status;
  }
  draw(cCoord: Coord, startRadian: number, endRadian: number, degree: number, cClockwise: boolean) {
    const sD = this.smallDistance;
    const radian = sD <= (76 + this.smallDistanceOffset) && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
    this.degree = degree;
    this.startRadian = startRadian;
    this.endRadian = endRadian;

    if (degree == 90) {
      this.arcStroke.clear();
      drawSquare(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
    } else {
      drawArc(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
      drawArc(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false)
    }

    const initialAngle = cClockwise ? endRadian : startRadian;
    this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
  }
}